import { render, staticRenderFns } from "./create-transaction.vue?vue&type=template&id=347393a6&"
import script from "./create-transaction.vue?vue&type=script&lang=js&"
export * from "./create-transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports